module.exports = __webpack_public_path__ + "img/ht.fb289ca0.svg";